const blueGrey500Color = '#153443';

export default blueGrey500Color;
